import { ChangeDetectionStrategy, Component, Inject, inject } from '@angular/core'
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatTooltipModule } from '@angular/material/tooltip'
import { SnapshotPayload } from '@core/models/snapshot.model'
import { SharedService } from '@core/services/share.service'
import { SnapshotService } from '@core/services/snapshot.service'
import { multipleEmailsValidator } from '@shared/others/multiple-email-validator'

@Component({
  selector: 'app-dialog-snapshot',
  templateUrl: './dialog-snapshot.component.html',
  styleUrl: './dialog-snapshot.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    // Forms
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,

    // Material
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
  ],
})
export class DialogSnapshotComponent {
  readonly dialogRef = inject(MatDialogRef<DialogSnapshotComponent>)

  snapshotForm = new FormGroup({
    name: new FormControl<string | null>(this.data.name ?? '', [Validators.required]),
    description: new FormControl<string | null>(this.data.description ?? ''),
    emails: new FormControl<string | null>(this.data.shared_with ?? '', [
      multipleEmailsValidator(),
    ]),
  })

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SnapshotPayload,
    private _snapShotService: SnapshotService,
    private _shareService: SharedService,
  ) {}

  cancel() {
    this.dialogRef.close()
  }

  async submitFormSnapshot() {
    const emailsFormControl = this.snapshotForm.get('emails') as FormControl<string | null> | null
    const emailsList = this._shareService.convertEmailsToList(emailsFormControl)
    const snapshotFormValue = this.snapshotForm.value
    if (!snapshotFormValue || !snapshotFormValue.name) {
      return
    }
    if (this.data.id) {
      // Edit snapshot
      const response = await this._snapShotService.updateSnapshot(
        this.data.id,
        snapshotFormValue.name,
        snapshotFormValue.description || undefined,
        emailsList,
      )
      if (response === null) return
    } else {
      // New snapshot
      const response = await this._snapShotService.addSnapshot(
        snapshotFormValue.name,
        snapshotFormValue.description || undefined,
        emailsList,
      )
      if (response === null) return
    }
    this._snapShotService.refreshSnapshots()
    this.dialogRef.close(true)
  }

  clear() {
    this.snapshotForm.get('name')?.reset()
  }
}
